import React from "react";
import * as R from "ramda";

import { connect } from "react-redux";

// import CSSModules from "react-css-modules";
import styles from "./styles.scss";
import Session from "./Session";

import { getters } from "../model";

const decorate = R.compose(
  connect(
    state => ({
      sessions: getters.sessions(state)
    }),
    {}
  )
);

const SessionList = ({ sessions = [] }) => {
  return (
    <div className={styles.listContainer}>
      {R.map(session => {
        const subsessions = R.propOr([], "subsessions", session);
        return (
          <>
            <Session
              key={session.id}
              {...session}
              instanceId={`session-${session.id}`}
            />
            {R.map(
              ss => (
                <Session
                  key={ss.id}
                  parentStatus={session.status}
                  {...ss}
                  instanceId={`session-${session.id}-subsession-${ss.id}`}
                />
              ),
              subsessions
            )}
          </>
        );
      }, sessions)}
    </div>
  );
};

export default decorate(SessionList);
